const situacoesDeMoradiaPropria = [
  'PropriaQuitada',
  'ConstrucaoNaoConcluida',
  'ImovelEmEstadoPrecario'
];

export default situacoesDeMoradiaPropria;